import { PageableResponse } from "../../../../../models/response.model";
import { ILancamentoAulasTableDTO } from "../../../../../models/happy-code-api.model";

export const getAulaNumero = (
  page: number,
  aulasTableData: PageableResponse<ILancamentoAulasTableDTO>,
  item: ILancamentoAulasTableDTO,
) => page * 10 + (aulasTableData?.content.indexOf(item) + 1);
